module.exports = __webpack_public_path__ + "img/icon_customization_white.bc515835.svg";